<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import NavigationBar from "./views/home/compoment/navigationBar";
export default {
  name: 'App',
  components: {NavigationBar}
}
</script>



// WEBPACK FOOTER //
// src/App.vue